export default "__VITE_PUBLIC_ASSET__435f06a9__"